<ng-container *ngIf="(reviewState$ | async) !== reviewStates.ReadOnly">
  <form [formGroup]="accountForm" class="account-selector">
    <div class="expand-container">
      <h2>{{ accountVerb$ | async }} Account</h2>
      <app-delete-icon-button
        *ngIf="canDelete$ | async"
        (click)="delete()"
      ></app-delete-icon-button>
    </div>
    <div *ngIf="hasError" class="error-descriptors">
      <ul>
        <li *ngFor="let error of errors">
          {{ error }}
        </li>
      </ul>
      <p>Please select another account or account type.</p>
    </div>
    <p *ngIf="!hasError">Select the type of account you are opening</p>
    <p class="attention">{{ accountRestrictionsText }}</p>
    <br />
    <h4>Account Details</h4>
    <app-select
      class="selector"
      #typeSelector
      label="Account Type"
      controlName="accountType"
      optionValueField="value"
      optionTextField="label"
      [options]="accountTypes"
      (selectionChange)="typeSelected($event)"
      [disabled]="!typeEnabled"
      [id]="'accountType'"
    ></app-select>
    <app-select
      class="selector"
      #accountSelector
      [id]="'account'"
      [ngClass]="{
        hidden: !(accounts$ | async),
        'control-has-error': hasError
      }"
      [label]="accountListLabel"
      controlName="account"
      optionValueField="value"
      optionTextField="label"
      [options]="(accounts$ | async) || []"
      (selectionChange)="accountSelected($event)"
      [disabled]="!accountEnabled"
    ></app-select>
    <br />
    <p>
      {{ accountObservations }}
      <ng-container *ngIf="ratesFeesLink">
        Rates and Annual Percentage Yields (APY) are accurate as of
        {{ getEffectiveDate() }}.
        <a
          [ngClass]="{ hidden: !(selectedAccount$ | async) }"
          target="_blank"
          [href]="ratesFeesLink"
          class="link-btn-action"
        >
          View Rates
        </a>
      </ng-container>
    </p>
    <ul class="account-detail-list">
      <li *ngFor="let feature of (accountFeatures$ | async) || []">
        {{ feature }}
      </li>
    </ul>
    <ng-container *ngIf="canViewAccountOptions$ | async">
      <br />
      <div *ngIf="isOrderDebit?.toLowerCase() === 'true'">
        <h4>Debit Card</h4>
        <span
          >Get a free debit card with the activation of your account to use at
          any ATM</span
        >
        <br />
        <mat-slide-toggle formControlName="orderDebitCard"
          >Order a debit card for this checking account</mat-slide-toggle
        >
        <div [ngClass]="{ hidden: !(canShowDebitCardOptions$ | async) }">
          <mat-checkbox formControlName="orderDebitCardForPrimary"
            >Primary</mat-checkbox
          ><br />
          <mat-checkbox formControlName="orderDebitCardForCoApplicant"
            >Co-applicant</mat-checkbox
          >
        </div>
      </div>
      <br />
      <div *ngIf="isOrderChecks?.toLowerCase() === 'true'">
        <h4>Checks</h4>
        <span>Get free checks the activation of your account</span>
        <br />
        <mat-slide-toggle formControlName="orderChecks"
          >Order checks for this checking account</mat-slide-toggle
        >
        <!--div [ngClass]="{ 'hidden': !(canShowCheckOptions$ | async)}">
          <mat-checkbox formControlName="orderChecksForPrimary">Primary</mat-checkbox><br>
          <mat-checkbox formControlName="orderChecksForCoApplicant">Co-applicant</mat-checkbox>
        </div-->
      </div>
    </ng-container>
    <br />
    <br />
    <br />
    <div class="expand-container">
      <button
        mat-stroked-button
        color="primary"
        class="secondary-btn-action"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
      class="primary-btn-action"
        mat-flat-button
        color="primary"
        [disabled]="!accountForm.valid"
        (click)="add()"
      >
        {{ actionVerb$ | async }}
      </button>
    </div>
  </form>
</ng-container>

<div
  *ngIf="(reviewState$ | async) === reviewStates.ReadOnly"
  class="account-selector-complete"
  [ngClass]="{ 'has-error': hasError }"
>
  <div
    [ngClass]="[highlightClass$ | async, 'highlight']"
    [style]="
      productStripeColor ? 'background-color: #' + productStripeColor : ''
    "
  ></div>
  <div fxFlex fxLayoutAlign="start center" class="content-action">
    <h3 class="heading-markup">
      <span fxFlex class="name">{{ accountName }}</span>
    </h3>
    <div fxFlex fxLayoutAlign="space-between center">
      <span *ngIf="accountAPYText">{{ accountAPYText }}</span>
      <span *ngIf="!accountAPYText"
        >{{ accountAPY }}% Annual Percentage Yield (APY)</span
      >
      <app-icon-button
        *ngIf="canEdit"
        icon="edit"
        label="EDIT"
        (click)="edit()"
      ></app-icon-button>
    </div>
  </div>
</div>
